/** Quais telas têm guia — só os nomes.
 *
 * Arquivo próprio, e propositalmente minúsculo: é a única coisa que o bundle de
 * entrada precisa saber sobre os guias. O texto de todos eles (`conteudo.ts`) e
 * o componente que os desenha ficam numa fatia carregada sob demanda; juntos,
 * eles custavam ~4,5 kB no primeiro carregamento, num orçamento que tem menos
 * de 6 kB de folga (ver `.size-limit.md`).
 *
 * Manter as duas listas em pé é o preço, e há teste que falha se elas
 * divergirem — uma tela declarada aqui e ausente do conteúdo montaria a fatia
 * para não mostrar nada.
 */

export const TELAS_COM_GUIA = new Set([
  "funil",
  "agenda",
  "arquivo",
  "indicadores",
  "etiquetas",
  "pessoas",
  "canal",
  "auditoria",
  "conta",
]);
